module.exports = __webpack_public_path__ + "media/images/gallery/constellations/dn_layer_off-2da6f2de499263fef1e58c7a7f24aaea.jpg";